import { useStorage } from '@hooks'
import { updateRating } from '@lib/firebase/api'
import { IStation, IVotes } from '@models'
import { useEffect, useState } from 'react'

export default function useRatings(station: IStation) {
    const [ratings, setRating] = useState<number>(0)
    const { set, get } = useStorage("ratings")

    useEffect(() => {
        const localRatings: { id: string, rating: number }[] = get() || []
        setRating(localRatings.find(r => r.id === station.id)?.rating || station.votes.total / station.votes.count)
    }, [station])

    const vote = async (current: number) => {
        const localRatings: { id: string, rating: number }[] = get() || []
        let newVotes: IVotes | undefined = station.votes
        const existingIndex = localRatings.findIndex(r => r.id === station.id)
        if (current === localRatings[existingIndex]?.rating) return
        if (existingIndex > -1) {
            station.votes.total += current - localRatings[existingIndex].rating
            newVotes = await updateRating(station.id, current - localRatings[existingIndex].rating, false)            
        } else {
            station.votes.total += current
            station.votes.count += 1
            newVotes = await updateRating(station.id, current, true)            
        }
        if (!newVotes) return
        if (existingIndex > -1)
            localRatings[existingIndex].rating = current
        else
            localRatings.push({ id: station.id, rating: current })
        set(localRatings)
        setRating(current)
    }

    return { ratings, vote }
}